import { turnToConfig } from 'init/config'

export function localizedPercentage(num: number, fractionDigits = 1): string {
  if (isNaN(num)) {
    return ''
  }
  const options = {
    style: 'percent',
    maximumFractionDigits: fractionDigits,
    minimumFractionDigits: fractionDigits
  }
  return num.toLocaleString(turnToConfig.locale.replace('_', '-'), options)
}

export function localizedThousandsInteger(num: number): number | string {
  return isNaN(num) || num < 1000 ? num : localizedNumber(num, 0)
}

export function localizedNumber(num: number, fractionDigits = 1): string {
  if (isNaN(num)) {
    return ''
  }
  const options = {
    maximumFractionDigits: fractionDigits,
    minimumFractionDigits: fractionDigits
  }
  return num.toLocaleString(turnToConfig.locale.replace('_', '-'), options)
}

export function localizedRating(average: number): string {
  return `${localizedNumber(average)} / ${localizedNumber(5.0)}`
}

export function localizedLanguage(locale: string): string {
  return locale.split('_')[0]
}
